import 'primevue/resources/themes/aura-light-green/theme.css';
import 'primevue/resources/primevue.min.css'; /* Deprecated */
import 'primeicons/primeicons.css';

import { createApp } from 'vue';

import PrimeVue from 'primevue/config';
import Clipboard from 'vue3-clipboard';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Vue3SocialSharingPlugin from "vue3-social-sharing";
import VueTelInput from 'vue-tel-input';
import * as Sentry from "@sentry/vue";

import BaseAvatar from '@/components/ui-kit/BaseAvatar/index.vue';
// global import ui-kit components
import BaseButton from '@/components/ui-kit/BaseButton/index.vue';
import BaseDropdown from '@/components/ui-kit/BaseDropdown/index.vue';
import BaseField from '@/components/ui-kit/BaseField/index.vue';
import BaseModal from '@/components/ui-kit/BaseModal/index.vue';
import BaseRange from '@/components/ui-kit/BaseRange/index.vue';
import BaseRangeSelect from '@/components/ui-kit/BaseRangeSelect/index.vue';
import BaseDropdownCodeCountry from '@/components/ui-kit/BaseDropdownCodeCountry/index.vue';
import BaseTextarea from '@/components/ui-kit/BaseTextarea/index.vue';
import BaseToggle from '@/components/ui-kit/BaseToggle/index.vue';

import App from './App.vue';
import router from './router';
import store from './store';
import sezAPI from '@/plugins/api.js';
import { useAPI } from '@/services/useAPI.js';
import linkWrappingPlugin from '@/plugins/linkWrappingPlugin.js';

linkWrappingPlugin(store);

const app = createApp(App);
app.component("BaseButton", BaseButton);
app.component("BaseField", BaseField);
app.component("BaseTextarea", BaseTextarea);
app.component("BaseDropdown", BaseDropdown);
app.component("BaseRange", BaseRange);
app.component("BaseModal", BaseModal);
app.component("BaseToggle", BaseToggle);
app.component("BaseAvatar", BaseAvatar);
app.component("BaseDropdownCodeCountry", BaseDropdownCodeCountry);
app.component("BaseRangeSelect", BaseRangeSelect);

const originalFetch = window.fetch;
window.fetch = async (input, init = {}) => {
  init = init || {};
  init.headers = {
    ...(init.headers || {}),
    "X-Sez-Platform": "web",
  };
  
  try {
    const response = await originalFetch(input, init);
    return response;
  } catch (error) {
    console.error('Fetch error:', {
      url: typeof input === 'string' ? input : input.url,
      method: init.method || 'GET',
      error: error.message
    });
        
    return new Response(JSON.stringify({
      error: true,
      message: 'Network request failed',
      statusCode: 0
    }), {
      status: 0,
      statusText: error.message
    });
  }
};

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV || "local",
  release: import.meta.env.VITE_APP_GIT_HASH,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: +(import.meta.env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
  // Session Replay
  replaysSessionSampleRate: +(
    import.meta.env.VITE_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0.0
  ),
  replaysOnErrorSampleRate: +(
    import.meta.env.VITE_APP_SENTRY_REPLAYS_ERROR_SAMPLE_RATE ?? 1.0
  ),
  sendDefaultPii: true,
  ignoreErrors: ["ChunkLoadError", "Loading chunk", "Loading CSS chunk"],
  beforeSend(event, hint) {
    console.debug("Sentry beforeSend", event, hint);

    // if (event.exception) {
    //   Sentry.showReportDialog({ eventId: event.event_id });
    // }

    return event;
  },
});

app.use(PrimeVue);
app.use(ToastService);
app.use(ConfirmationService);
app.use(Vue3SocialSharingPlugin);
app.use(Clipboard, { autoSetContainer: true, appendToBody: true });
app.use(VueTelInput, {
  dropdownOptions: {
    showDialCode: true,
    showSearchBox: true,
    searchBoxPlaceholder: "Search country",
  }
});
app.use(store);
app.use(router);
app.use(sezAPI);
app.provide('useAPI', useAPI);

app.mount("#app");